import { NgFor, NgIf } from '@angular/common';
import {
  afterNextRender,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { Product } from 'src/app/classes/utility';
import { DrawerComponent } from 'src/app/components/drawer/drawer.component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { StoryBlokService } from 'src/app/service/storyblok.service';
import { BackInStockComponent } from './components/back-in-stock/back-in-stock.component';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { MetaComponent } from './components/meta/meta.component';
import { OkendoComponent } from './components/okendo/okendo.component';
import { StickyAddToCartComponent } from './components/sticky-add-to-cart/sticky-add-to-cart.component';
import { ProductService } from './product.service';

@Component({
  selector: 'app-shopify-product',
  imports: [
    DynamicModule,
    StoryblokDirective,
    NgIf,
    NgFor,
    ImageGalleryComponent,
    MetaComponent,
    OkendoComponent,
    BackInStockComponent,
    DrawerComponent,
    StickyAddToCartComponent,
  ],
  templateUrl: './shopify-product.component.html',
  styleUrl: './shopify-product.component.scss',
})
export class ContentSourceShopifyProductComponent {
  product!: Product;
  story: any;
  @Input() _editable!: string;

  components: any;

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private storyBlokService: StoryBlokService,
    private cd: ChangeDetectorRef
  ) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = { ...cp.Components, okendo: OkendoComponent };
    });
    afterNextRender(() => {
      try {
        window.storyblok.on('input', (event: any) => {
          if (
            this.story &&
            event.story.content._uid === this.story?.content?._uid
          ) {
            this.story = event.story;
            this.cd.markForCheck();
          }
        });
      } catch (err) {
        console.log('not in visual editor');
      }
    });

    this.route.data.subscribe(async (data: any) => {
      this.product = data?.product;

      this.productService.variantSubject.next(this.product.variants[0]);
      let slugs = [];
      if (this.product.metafields?.product?.storyblok) {
        slugs.push(this.product.metafields.product?.storyblok);
      }
      slugs.push('products/' + this.product.handle);
      slugs.push('products/');
      this.story = await this.storyBlokService
        .getStories({
          by_slugs: slugs.join(','),
        })
        .then((data) => {
          const overrideMatch =
            this.product.metafields?.product?.storyblok &&
            data.stories.find((x) =>
              x.full_slug.includes(this.product.metafields?.product?.storyblok)
            );
          if (overrideMatch) {
            return overrideMatch;
          }
          const handleMatch = data.stories.find((x) =>
            x.full_slug.includes(this.product.handle)
          );

          if (handleMatch) return handleMatch;
          const defaultMatch = data.stories.find((x) =>
            x.full_slug.includes('products')
          );

          return defaultMatch;
        })
        .then((data) => {
          if (data?.content) {
            data.content.body.forEach((blok: any) => {
              if (blok.component == 'okendo') {
                blok.product = this.product;
              }
            });
          }
          return data;
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }
}
